/* global __APP_VERSION__ */
import { lazy } from 'react';

import { type Version } from '@storebrand-digital/fms-translations/dist/types';
import FlagProvider from '@unleash/proxy-client-react';
import { createRoot } from 'react-dom/client';

import { FlexStyleSheet, SpacingStyleSheet } from '@storebrand-digital/bank-foundation-helper-styles';
import { init as initFMS } from '@storebrand-digital/fms-translations';

import { ApiServiceProvider } from '@api/context/ApiServiceContext';
import { HttpServiceProvider } from '@api/context/HttpServiceContext';

import auth from './auth';
import MonitoringProvider from './logger/provider/MonitoringProvider';
import OnboardingRouter from './onboardingRouter';
import en from './translations/fallback-en.json';
import no from './translations/fallback-no.json';
import getUnleashConfig from './utils/unleash';
import './index.css';

const OnboardingNavbar = lazy(() => import('./components/OnboardingNavbar'));

function App() {
  return (
    <>
      <OnboardingNavbar />
      <FlagProvider config={getUnleashConfig()}>
        <SpacingStyleSheet />
        <FlexStyleSheet />
        <HttpServiceProvider>
          <ApiServiceProvider>
            <MonitoringProvider version={__APP_VERSION__}>
              <OnboardingRouter />
            </MonitoringProvider>
          </ApiServiceProvider>
        </HttpServiceProvider>
      </FlagProvider>
    </>
  );
}

// TODO: Move init functions to InitProvider
async function bootstrap() {
  await initFMS({
    clientId: window.env.CLIENT_ID,
    documentIds: ['bankOnboarding'],
    fallback: { no, en },
    version: window.env.TRANSLATION_VERSION as Version,
  });

  await auth.init();

  const rootNode = document.getElementById('root');

  if (!rootNode) {
    throw new Error('Cannot mount react, #root element is not available');
  }

  createRoot(rootNode).render(<App />);
}

await bootstrap();
